// src/components/common/ContentFilters.js

import React from 'react';

/**
 * کامپوننت UI برای اعمال مرتب‌سازی و فیلترها روی محتوای لیست
 * @param {object} filters - آبجکت شامل: {sortOrder, isFree}
 * @param {function} setFilters - تابع برای به‌روزرسانی فیلترها
 */
const ContentFilters = ({ filters, setFilters }) => {

    const handleSortChange = (e) => {
        setFilters(prev => ({ 
            ...prev, 
            sortOrder: e.target.value 
        }));
    };

    // ✅ اصلاح: مدیریت سه حالت (همه، رایگان، خریدنی)
    const handleFreeFilterChange = () => {
        setFilters(prev => {
            // اگر فعلاً null است (همه) -> true (رایگان)
            if (prev.isFree === null) {
                return { ...prev, isFree: true };
            }
            // اگر فعلاً true است (رایگان) -> false (خریدنی)
            if (prev.isFree === true) {
                return { ...prev, isFree: false };
            }
            // اگر فعلاً false است (خریدنی) -> null (همه)
            return { ...prev, isFree: null };
        });
    };

    // ✅ تابع برای نمایش وضعیت فعلی فیلتر
    const getFilterLabel = () => {
        if (filters.isFree === null) return 'همه';
        if (filters.isFree === true) return 'رایگان';
        return 'خریدنی';
    };

    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center 
                        p-4 bg-gray-50 border-b border-gray-200 sticky top-0 z-20 mx-auto max-w-[460px] w-full rtl">
            
            {/* ۱. مرتب سازی (Sort) */}
            <div className="flex items-center space-x-reverse space-x-2 mb-3 sm:mb-0">
                <label 
                    htmlFor="sort-order" 
                    className="text-xs font-medium text-gray-700 flex-shrink-0"
                >
                    مرتب‌سازی:
                </label>
                <select
                    id="sort-order"
                    value={filters.sortOrder}
                    onChange={handleSortChange}
                    className="p-1 text-xs font-medium text-gray-800 border border-gray-300 rounded-md 
                               focus:ring-indigo-500 focus:border-indigo-500"
                >
                    <option value="newest">جدیدترین</option>
                    <option value="likes">تعداد لایک</option>
                </select>
            </div>

            {/* ۲. فیلتر رایگان/خریدنی (چرخه‌ای) */}
            <div className="flex items-center space-x-reverse space-x-2 cursor-pointer" onClick={handleFreeFilterChange}>
                <div className="flex items-center gap-2">
                    {/* ✅ دکمه چرخه‌ای با نمایش وضعیت */}
                    <span className="text-xs font-medium text-gray-700">فیلتر:</span>
                    <span className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${
                        filters.isFree === null 
                            ? 'bg-gray-200 text-gray-700' 
                            : filters.isFree === true 
                                ? 'bg-green-100 text-green-700' 
                                : 'bg-blue-100 text-blue-700'
                    }`}>
                        {getFilterLabel()}
                    </span>
                    {/* آیکون چرخه */}
                    <svg 
                        className={`w-4 h-4 transition-transform duration-300 ${
                            filters.isFree !== null ? 'rotate-180' : ''
                        }`} 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default ContentFilters;